import { ErrorHandler, Injectable } from '@angular/core';
import { LoggingService } from './logging.service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

    constructor(private loggingService: LoggingService) {
        super();
    }

    handleError(error: Error) {
        const message = error?.toString() || '';
        if (message.includes('Loading chunk') || message.includes('ChunkLoadError')) {
            window.location.reload();
            return
        } else {
            this.loggingService.logException(error); // Manually log exception
            const originalError = this.getOriginalError(error);
            if (originalError !== error) {
                this.loggingService.logException(originalError); // Manually log original exception
            }
        } 
    }

    private getOriginalError(error: any) {
        while (error && error.originalError) {
            error = error.originalError;
        }
        return (error);
    }
}